import { useHotkeysContext } from 'react-hotkeys-hook';

import { createContext, forwardRef, useContext } from 'react';

export * from 'react-hotkeys-hook';

interface HotkeysScopeContext {
	scope: string;
}

const Context = createContext<HotkeysScopeContext>({} as HotkeysScopeContext);

export const HotkeysScopeProvider = forwardRef<
	HTMLDivElement,
	{ scope: string; children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>
>(({ scope, children, ...rest }, ref) => {
	const { enableScope, disableScope } = useHotkeysContext();

	return (
		<div
			ref={ref}
			{...rest}
			tabIndex={-1}
			onFocus={() => {
				enableScope(scope);
			}}
			onBlur={() => {
				disableScope(scope);
			}}
		>
			<Context.Provider value={{ scope }}>{children}</Context.Provider>
		</div>
	);
});

HotkeysScopeProvider.displayName = 'HotkeysScopeProvider';

export const useHotkeysScope = () => {
	const context = useContext(Context);
	if (!context) {
		throw new Error('useHotkeysScope must be used within a HotKeysProvider');
	}
	return context;
};
